var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClipboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33203 2.3335H10.4987C10.8081 2.3335 11.1049 2.45641 11.3237 2.6752C11.5424 2.894 11.6654 3.19074 11.6654 3.50016V11.6668C11.6654 11.9762 11.5424 12.273 11.3237 12.4918C11.1049 12.7106 10.8081 12.8335 10.4987 12.8335H3.4987C3.18928 12.8335 2.89253 12.7106 2.67374 12.4918C2.45495 12.273 2.33203 11.9762 2.33203 11.6668V3.50016C2.33203 3.19074 2.45495 2.894 2.67374 2.6752C2.89253 2.45641 3.18928 2.3335 3.4987 2.3335H4.66536",
    stroke: "#024773",
    strokeWidth: 1.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7513 1.1665H5.2513C4.92914 1.1665 4.66797 1.42767 4.66797 1.74984V2.9165C4.66797 3.23867 4.92914 3.49984 5.2513 3.49984H8.7513C9.07347 3.49984 9.33464 3.23867 9.33464 2.9165V1.74984C9.33464 1.42767 9.07347 1.1665 8.7513 1.1665Z",
    stroke: "#024773",
    strokeWidth: 1.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/clipboard.5f9df3df504c3b40caeb60f237517f2a.svg";
export { ForwardRef as ReactComponent };